module.exports = require("core-js-pure/stable/instance/concat");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/instance/concat.js
// module id = 589
// module chunks = 0